import { Chip } from '@mui/material'
import {
  DistributionListSportKey,
  distributionListSportLabelsMap
} from '@/constants/distributionList'

export const DistributionSportChip = ({ sport }: { sport: DistributionListSportKey | 'ALL' }) => {
  if (sport === 'ALL') {
    return <Chip size="small" label="All Sports" />
  }

  return (
    <Chip
      size="small"
      key={sport}
      label={distributionListSportLabelsMap[sport]}
      data-testid="distribution-list-sport-chip"
    />
  )
}
